import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Cards from "../HOME/Card";
import { API_URL } from "../API/config";
import axios from "axios";
import { message, Pagination, Empty, Select } from "antd";
import { useParams } from "react-router-dom";

const ProductView = () => {
  const { category } = useParams();
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();
  const itemsPerPage = 12;

  const errormessage = (content: any) => {
    messageApi.open({
      type: "error",
      content: content,
      className: "custom-class",
    });
  };

  const [filterValue, setFilterValue] = useState("");

  const getProduct = async () => {
    const token = sessionStorage.getItem("token");


    try {
      const res = await axios.get(`${API_URL}/api/products?${filterValue}=true`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (category) {
        const categoryFiltered = res.data.filter(
          (val: any) => val.categories.toLowerCase() === category.toLowerCase()
        );
        setFilteredData(categoryFiltered);
      } else {
        setFilteredData(res.data);
      }
    } catch (error) {
      errormessage("Failed to load products.");
    }
  };

  useEffect(() => {
    getProduct();
  }, [category,filterValue]);

  

  // Calculate the paginated data to display
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <>
      {contextHolder}
      <section style={{ paddingTop: "6rem" }} className="pb-4">
        <Container>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <p className="title-para">Home - Product</p>
              <h2 className="title-navhead">Products</h2>
            </div>
            <div>
              <Select
                placeholder="Filter Price"
                style={{ width: 160, height: 40 }}
                options={[
                  { value: "highPrice", label: "Price High to Low" },
                  { value: "lowPrice", label: "Price Low to High" },
                ]}
                onChange={(value) => setFilterValue(value)}
              />
            </div>
          </div>

          <div className="row py-3">
            {currentData.length > 0 ? (
              <Cards product={currentData} />
            ) : (
              <div className="d-flex justify-content-center w-100 py-5">
                <Empty description="No items found" />
              </div>
            )}
          </div>

          {/* Pagination Controls */}
          {filteredData.length > itemsPerPage && (
            <Pagination
              current={currentPage}
              pageSize={itemsPerPage}
              total={filteredData.length}
              onChange={handlePageChange}
              className="d-flex justify-content-center mt-3"
            />
          )}
        </Container>
      </section>
    </>
  );
};

export default ProductView;
